"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleCo2Class = void 0;
const core_1 = require("@angular/core");
let VehicleCo2Class = class VehicleCo2Class {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], VehicleCo2Class.prototype, "co2", void 0);
VehicleCo2Class = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-co2-class',
        template: /* html */ `
    <ng-container *ngIf="co2 === 0">A</ng-container>

    <ng-container *ngIf="co2 > 0 && co2 <= 95">B</ng-container>

    <ng-container *ngIf="co2 >= 96 && co2 <= 115">C</ng-container>

    <ng-container *ngIf="co2 >= 116 && co2 <= 135">D</ng-container>

    <ng-container *ngIf="co2 >= 136 && co2 <= 155">E</ng-container>

    <ng-container *ngIf="co2 >= 156 && co2 <= 175">F</ng-container>

    <ng-container *ngIf="co2 >= 176">G</ng-container>
  `,
    })
], VehicleCo2Class);
exports.VehicleCo2Class = VehicleCo2Class;
